import styled from 'styled-components';

export const Container = styled.div`
display: flex;
grid-area: graphMobile;
margin-top: 5%;
margin-bottom: 5%;
width: 100%;
padding-left: 2% ;
  justify-content: center;
  @media (min-width: 821px) {
      display: none;
   }
`;

export const SquareContainer = styled.div`
width: 80px;
height: 100px;
border-right: 1px solid #C4C3C3;
border-left: 1px solid #C4C3C3;
border-top: 1px solid #C4C3C3;
border-bottom: 1px solid #C4C3C3;
display: flex;
flex-direction: column;
p{
  margin: 0;
}
p:nth-child(1){
 
}
p:nth-child(2){
  font-weight: 400;

}
.header{
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  height: 20%;
}
.ContainerFlower{
  height: 80%;
  display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

`
export const SquareContainerFake = styled.div`
width: 80px;
height: 100px;
border-left: 1px solid #C4C3C3;
display: flex;
flex-direction: column;


`
export const Control = styled.div`
display: flex;
flex-wrap: wrap;
width: 90%;
`

export const BoxTooltip = styled.div`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  padding: 50px;
`
